import React from "react";
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: "dark" | "light";
  align?: "center" | "left";
  className?: string;
};
export function SectionHeading({
  title,
  subtitle,
  tone = "dark",
  align = "center",
  className = ""
}: SectionHeadingProps) {
  const alignment = align === "center" ? "mx-auto text-center" : "text-left";
  return <div className={`max-w-3xl ${alignment} ${className}`} data-id="element-219" data-mp="bjtx1v8k6m1l">
      <h2 className={`font-display text-[1.85rem] font-bold leading-[1.15] md:text-[2.6rem] md:leading-[1.1] ${tone === "dark" ? "text-royal" : "text-white"}`} data-id="element-220" data-mp="bmgdylhcadwh">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base leading-relaxed md:text-lg ${tone === "dark" ? "text-cocoa-soft" : "text-white/90"}`} data-id="element-221" data-mp="6sveep03lbv6">
          {subtitle}
        </p>}
    </div>;
}